export default __webpack_public_path__ + "static/media/bedroom.899e883c.jpeg";